jQuery(document).ready(function ($) {

    $(".video").each(function () {
        $(this).find('.video__play').on('click', function (e) {
            e.preventDefault();
            $(this).prev(".video__player")[0].src += "?autoplay=1";
            $(this).hide();
        });
    });
});